import { useState } from 'react';
import { SOLUTION_TABS, SOLUTIONS } from '../../data/solutions';
import Reveal from '../ui/Reveal';

export default function Solutions() {
  const [tab, setTab] = useState('founders');
  const s = SOLUTIONS[tab];

  return (
    <section className="sect" id="s-solutions">
      <div className="container">
        <Reveal>
          <h2 className="sect-h2">
            AI insight for <span className="dim">every team</span>
          </h2>
          <p className="sect-sub">Your key workflows, understood by Pattern Intelligence.</p>
        </Reveal>
        <div className="tabs" id="solTabs">
          {SOLUTION_TABS.map((t) => (
            <button
              key={t.key}
              type="button"
              className={`tab${tab === t.key ? ' on' : ''}`}
              onClick={() => setTab(t.key)}
            >
              {t.label}
            </button>
          ))}
          <a className="tab-link" href="/monitoring">
            See all teams →
          </a>
        </div>

        <div className="sol-card">
          <div className="sol-left">
            <h3 id="solTitle">{s.t}</h3>
            <p className="sd" id="solDesc">
              {s.d}
            </p>
            <ul className="sol-list" id="solList">
              {s.l.map((x) => (
                <li key={x}>
                  <span className="sarr">→</span>
                  {x}
                </li>
              ))}
            </ul>
            <ul className="agent-list" id="solAgents">
              {s.a.map(([ch, c, txt]) => (
                <li key={`${ch}-${txt}`}>
                  <span className="aico" style={{ background: c }}>
                    {ch}
                  </span>
                  <span dangerouslySetInnerHTML={{ __html: txt }} />
                </li>
              ))}
            </ul>
            <a className="sol-more" href="/pattern-intelligence">
              Explore solution →
            </a>
          </div>
          <div className="sol-right">
            <div className="sol-shot">
              <div
                style={{
                  display: 'flex',
                  gap: '6px',
                  padding: '10px 12px',
                  borderBottom: '1px solid #f2f3f5',
                }}
              >
                <span style={{ width: '9px', height: '9px', borderRadius: '50%', background: '#ff5f57' }} />
                <span style={{ width: '9px', height: '9px', borderRadius: '50%', background: '#febc2e' }} />
                <span style={{ width: '9px', height: '9px', borderRadius: '50%', background: '#28c840' }} />
              </div>
              <div style={{ padding: '18px 20px 22px' }}>
                <div
                  style={{
                    fontSize: '11px',
                    fontWeight: '700',
                    letterSpacing: '1.6px',
                    color: '#83848c',
                    marginBottom: '10px',
                  }}
                >
                  FOUNDER&apos;S REPORT — MON 9:00 AM
                </div>
                <div
                  style={{
                    fontSize: '15px',
                    fontWeight: '700',
                    color: '#090c1d',
                    marginBottom: '12px',
                  }}
                >
                  Week of Jul 6 — 5 wins · 3 risks
                </div>
                <div
                  style={{
                    height: '10px',
                    borderRadius: '5px',
                    background: 'linear-gradient(90deg,#2DBDB8 62%,#f0f1f4 62%)',
                    marginBottom: '8px',
                  }}
                />
                <div
                  style={{
                    height: '10px',
                    borderRadius: '5px',
                    background: 'linear-gradient(90deg,#469FD8 44%,#f0f1f4 44%)',
                    marginBottom: '8px',
                  }}
                />
                <div
                  style={{
                    height: '10px',
                    borderRadius: '5px',
                    background: 'linear-gradient(90deg,#6C59A6 78%,#f0f1f4 78%)',
                    marginBottom: '16px',
                  }}
                />
                <div style={{ display: 'flex', gap: '8px' }}>
                  <span
                    style={{
                      fontSize: '11px',
                      fontWeight: '700',
                      padding: '4px 10px',
                      borderRadius: '6px',
                      background: '#e9f6f0',
                      color: '#1d7a43',
                    }}
                  >
                    Sales +18%
                  </span>
                  <span
                    style={{
                      fontSize: '11px',
                      fontWeight: '700',
                      padding: '4px 10px',
                      borderRadius: '6px',
                      background: '#fdece8',
                      color: '#b43a18',
                    }}
                  >
                    2 burnout risks
                  </span>
                  <span
                    style={{
                      fontSize: '11px',
                      fontWeight: '700',
                      padding: '4px 10px',
                      borderRadius: '6px',
                      background: '#eaf2fb',
                      color: '#2c66a8',
                    }}
                  >
                    Focus +6%
                  </span>
                </div>
              </div>
            </div>
            <div className="replaces">
              <span className="rl">REPLACES</span>
              <span className="rn">Time Doctor</span>
              <span className="rn">Hubstaff</span>
              <span className="rn">ActivTrak</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
